import type * as types from '../types';

import { ConstrainMaxHeightToViewport } from './constrain-height-to-viewport';

const ModifierConfigurations = {
  ConstrainMaxHeightToViewport,
} as const satisfies {
  [key in types.CustomModifierName]: new () => types.IModifierConfiguration<key>;
};

/**
 * Returns the configuration instance, {@link IModifierConfiguration}, for the custom modifier
 * with the given name.
 *
 * @param {N} name The name of the custom modifier for which the configuration should be retrieved.
 *
 * @returns {InstanceType<(typeof ModifierConfigurations)[N]>}
 *   The configuration instance for the specified custom modifier.
 */
export const getModifierConfiguration = <N extends keyof typeof ModifierConfigurations>(
  name: N,
): InstanceType<(typeof ModifierConfigurations)[N]> => {
  const ConfigurationClass: (typeof ModifierConfigurations)[N] = ModifierConfigurations[name];
  const instance = new ConfigurationClass();
  return instance as InstanceType<(typeof ModifierConfigurations)[N]>;
};
